import { render, staticRenderFns } from "./ComplaintDamageMineList.vue?vue&type=template&id=24978586&scoped=true"
import script from "./ComplaintDamageMineList.vue?vue&type=script&lang=js"
export * from "./ComplaintDamageMineList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDamageMineList.vue?vue&type=style&index=0&id=24978586&prod&lang=scss"
import style1 from "./ComplaintDamageMineList.vue?vue&type=style&index=1&id=24978586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24978586",
  null
  
)

export default component.exports